import { httpClient, HttpMethod } from './http-client';

export const getVisibilityRules = (): any => {
  return httpClient('/visibilityrules', HttpMethod.Get, null);
};

export const getVisibilityRuleById = (id: number) => {
  return httpClient(`/visibilityrules/${id}`, HttpMethod.Get, null);
};

export const getCurrentUserVisibility = () => {
  return httpClient('/getVisibilityRuleAccess', HttpMethod.Get, null);
};